export const DASHBOARD_PLAYLIST_RESULT_LIMIT = 100;

export const isDashboardWebPlayerLaunch = (search = "") =>
  new URLSearchParams(search).get("from") === "dashboard";

const searchablePlaylistFields = (playlist) => [
  playlist.accountName,
  playlist.fullName,
  playlist.username,
  playlist.domain,
  playlist.name,
  playlist.code,
];

export const prepareDashboardPlaylists = (playlists = []) =>
  playlists
    .filter(
      (playlist) =>
        playlist?.id &&
        playlist?.code &&
        String(playlist.status || "").toLowerCase() === "active"
    )
    .map((playlist) => ({
      ...playlist,
      accountName: playlist.accountName || "",
      expiresAt: playlist.expiresAt || playlist.expiry_date || null,
      fullName: playlist.fullName || "",
      name:
        playlist.name ||
        playlist.accountName ||
        playlist.domain ||
        playlist.username ||
        "Playlist",
    }))
    .sort((left, right) =>
      String(left.name).localeCompare(String(right.name), undefined, {
        sensitivity: "base",
      })
    );

export const searchDashboardPlaylists = (playlists, search = "") => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) return playlists;

  return playlists.filter((playlist) =>
    searchablePlaylistFields(playlist).some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(normalizedSearch)
    )
  );
};

export const limitDashboardPlaylistResults = (
  playlists,
  limit = DASHBOARD_PLAYLIST_RESULT_LIMIT
) => playlists.slice(0, limit);
